import { addMethod, string } from 'yup';
import { type CountryCode, ParseError, parsePhoneNumberWithError } from 'libphonenumber-js';

import { buildMessageCallback } from '../utilities';
import { phoneValidationMessages } from './phone-number-validator-messages';

declare module 'yup' {
  interface StringSchema {
    isValidPhoneNumberForCountry(countryCode?: CountryCode | string): StringSchema;
  }
}

const PARSE_ERROR_MESSAGES: Record<string, object> = {
  NOT_A_NUMBER: phoneValidationMessages.notANumber,
  TOO_SHORT: phoneValidationMessages.tooShort,
  TOO_LONG: phoneValidationMessages.tooLong,
  INVALID_COUNTRY: phoneValidationMessages.invalidCountry,
};

addMethod(string, 'isValidPhoneNumberForCountry', function (countryCode: CountryCode = 'US') {
  return this.test('is-valid-phone-number', buildMessageCallback(phoneValidationMessages.fallback), function (value) {
    if (!value) return false;

    try {
      const phoneNumber = parsePhoneNumberWithError(value, countryCode);
      return phoneNumber.isValid();
    } catch (error) {
      if (error instanceof ParseError) {
        const messageDescriptor = PARSE_ERROR_MESSAGES[error.message];

        if (messageDescriptor) {
          return this.createError({ message: buildMessageCallback(messageDescriptor) });
        }
      }

      return false;
    }
  });
});
